//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectNXObject.js";
import "../no/SelectObject.js";
let d=[[[0,"CsysRefType",1,0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"ExtentType",1,0],[0,"ILine",1,0],[0,"INormal",1,0],[0,"JLine",1,0],[0,"JNormal",1,0],[0,"KLine",1,0],[0,"KNormal",1,0],[0,"Length",1,0],[0,"LineDirection",1,"Direction",0],[0,"Name",1,0],[1,"OffsetDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"ReverseDirection",1,0],[1,"SelectLine",0,"SelectNXObject",0],[1,"SelectNormalSurface",0,"SelectNXObject",0],[0,"X",1,0],[0,"Y",1,0],[0,"Z",1,0]],[[[],"UpdateParams",{},0,0],[[],"FlipLineDirection",{},0,0],[[],"UpdateNormal",{},0,0],[[],"FlipNormal",{},0,0],[["normalSurface"],"SetNormalSurface",{},1,0],[[],"ReverseOffsetDirection",{},0,0],[[],"UpdateOffset",{},0,0]],[]];
SPLM.CAM.InspectionLineFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionLineFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;